// extracted by mini-css-extract-plugin
module.exports = {"penalty-card":"penaltyCard__penalty-card___2JC1y","red":"penaltyCard__red___1hldC"};